import type { DueEntryT } from "@patient-watch/types";

export interface WorklistFormSlot {
    scheduleId: string;
    scheduleIndex: number;
}

/** Prefer an unlocked due slot, then a sequence-blocked upcoming slot. */
export function resolveWorklistFormSlot(tracker: {
    due_entries?: (DueEntryT | null)[] | null;
    upcoming_entries?: (DueEntryT | null)[] | null;
    next_entry?: DueEntryT | null;
}): WorklistFormSlot | null {
    const unlocked = (tracker.due_entries ?? []).find(
        (entry) => entry != null && entry.schedule_id && entry.schedule_index != null && entry.is_locked !== true
    );
    if (unlocked?.schedule_id != null && unlocked.schedule_index != null) {
        return { scheduleId: unlocked.schedule_id, scheduleIndex: unlocked.schedule_index };
    }

    const sequenceBlocked = (tracker.upcoming_entries ?? []).find(
        (entry) =>
            entry != null && entry.lock_reason === "sequence" && entry.schedule_id && entry.schedule_index != null
    );
    if (sequenceBlocked?.schedule_id != null && sequenceBlocked.schedule_index != null) {
        return { scheduleId: sequenceBlocked.schedule_id, scheduleIndex: sequenceBlocked.schedule_index };
    }

    const next = tracker.next_entry;
    if (next?.schedule_id && next.schedule_index != null) {
        return { scheduleId: next.schedule_id, scheduleIndex: next.schedule_index };
    }

    return null;
}

export function formWorklistItemId(diaryId: string, trackerId: string, slot: WorklistFormSlot): string {
    return `${diaryId}:form:${trackerId}:${slot.scheduleId}:${slot.scheduleIndex}`;
}

export function eventDetailsWorklistItemId(diaryId: string, eventId: string | null | undefined): string {
    return eventId ? `${diaryId}:event_details:${eventId}` : `${diaryId}:event_details`;
}

export function consentWorklistItemId(diaryId: string, consentId: string): string {
    return `${diaryId}:consent:${consentId}`;
}
